import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Globe } from 'lucide-react';
export function CoverageMap() {
  const locations = ['MCO Orlando', 'FLL Fort Lauderdale', 'MIA Miami', 'Barranquilla', 'Cartagena', 'Medellin', 'El Salvador'];
  // Map coordinates (relative percentages for positioning on the SVG viewBox)
  const dots = [{
    id: 'mia',
    cx: '78%',
    cy: '85%',
    label: 'MIA'
  }, {
    id: 'fll',
    cx: '79%',
    cy: '82%',
    label: 'FLL'
  }, {
    id: 'mco',
    cx: '76%',
    cy: '75%',
    label: 'MCO'
  }, {
    id: 'lax',
    cx: '15%',
    cy: '55%',
    label: 'LAX'
  }, {
    id: 'dfw',
    cx: '50%',
    cy: '65%',
    label: 'DFW'
  }, {
    id: 'jfk',
    cx: '85%',
    cy: '35%',
    label: 'JFK'
  }, {
    id: 'ord',
    cx: '65%',
    cy: '35%',
    label: 'ORD'
  }, {
    id: 'sea',
    cx: '15%',
    cy: '15%',
    label: 'SEA'
  }];
  return <section id="coverage" className="py-24 bg-navy relative border-b border-white/5 overflow-hidden" data-id="element-177" data-mp="qg2lxp57ytg7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178" data-mp="hdb67d5b9bir">
        <div className="text-center mb-16 relative z-10" data-id="element-179" data-mp="hew0r2rmkugm">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 uppercase" data-id="element-180" data-mp="mbcs05u4foxx">
            From Coast To Coast, We Deliver.
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-181" data-mp="1a430g52tfq3g">
            Serving aircraft operators all over the United States and beyond.
          </p>
        </div>

        {/* Stylized Map Container */}
        <div className="relative w-[70%] mx-auto aspect-[16/9] mb-16" data-id="element-182" data-mp="15b0cccgt58un">
          {/* Abstract US Map SVG Path */}
          <svg viewBox="0 0 1000 600" className="w-full h-full drop-shadow-2xl" preserveAspectRatio="xMidYMid meet" data-id="element-183" data-mp="1t01exj2ylps0">
            <path d="M150,100 L250,80 L400,120 L550,100 L700,150 L850,120 L900,200 L880,300 L920,400 L850,450 L750,550 L700,500 L600,520 L500,580 L400,500 L250,480 L150,400 L100,300 L80,200 Z" fill="#111827" stroke="#1f2937" strokeWidth="2" className="transition-all duration-1000" data-id="element-184" data-mp="1xt4cs3errle0" />

            {/* Connection Lines */}
            <defs data-id="element-185" data-mp="1ssdfk00zkvnq">
              <filter id="goldGlow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-186" data-mp="1oo5se7a6fnrm">
                <feGaussianBlur stdDeviation="3" result="coloredBlur" data-id="element-187" data-mp="1jvuoktcbfhts" />
                <feMerge data-id="element-188" data-mp="1ez4eqnr3tigt">
                  <feMergeNode in="coloredBlur" data-id="element-189" data-mp="1ew9ougpbn5g0" />
                  <feMergeNode in="SourceGraphic" data-id="element-190" data-mp="1a0knq8xnlghl" />
                </feMerge>
              </filter>
            </defs>
            <motion.path d="M780,510 L790,492 L760,450 L500,390 L150,330" fill="none" stroke="#C9A84C" strokeWidth="2" strokeDasharray="6,4" filter="url(#goldGlow)" initial={{
            pathLength: 0,
            opacity: 0
          }} whileInView={{
            pathLength: 1,
            opacity: 0.9
          }} transition={{
            duration: 2,
            ease: 'easeInOut'
          }} data-id="element-191" data-mp="14zx07x8mvhs4" />
            <motion.path d="M780,510 L850,210 L650,210 L150,90" fill="none" stroke="#C9A84C" strokeWidth="2" strokeDasharray="6,4" filter="url(#goldGlow)" initial={{
            pathLength: 0,
            opacity: 0
          }} whileInView={{
            pathLength: 1,
            opacity: 0.9
          }} transition={{
            duration: 2,
            delay: 0.5,
            ease: 'easeInOut'
          }} data-id="element-192" data-mp="2sz8sx2mmu106" />
          </svg>

          {/* Map Dots */}
          {dots.map(dot => <div key={dot.id} className="absolute transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center" style={{
          left: dot.cx,
          top: dot.cy
        }} data-id="element-193" data-mp="gpirttaizcel">
              <div className="relative flex items-center justify-center" data-id="element-194" data-mp="pnknrufejev0">
                <span className="absolute w-6 h-6 rounded-full bg-gold/30 blur-md animate-pulse" data-id="element-195" data-mp="14d0amzbtb05f"></span>
                <motion.div className="relative w-3 h-3 bg-gold rounded-full" style={{
              boxShadow: '0 0 12px 4px rgba(201, 168, 76, 0.7), 0 0 24px 8px rgba(201, 168, 76, 0.35)'
            }} animate={{
              scale: [1, 1.5, 1],
              opacity: [1, 0.6, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              delay: Math.random() * 2
            }} data-id="element-196" data-mp="zeyr6dah4ytf" />
              </div>
              <span className="text-white/70 text-[10px] font-bold mt-1 tracking-wider hidden sm:block" data-id="element-197" data-mp="1uqok6lid8xjw">
                {dot.label}
              </span>
            </div>)}
        </div>

        {/* Location Badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12 relative z-10" data-id="element-198" data-mp="16z9f4kz7g24y">
          {locations.map((loc, idx) => <div key={idx} className="bg-navy-light border border-white/10 rounded-full px-5 py-2 flex items-center hover:border-gold/50 transition-colors" data-id="element-199" data-mp="1bz48cv6gd3t6" data-mpi={idx}>
              <MapPin className="w-4 h-4 text-gold mr-2" data-id="element-200" data-mp="120y7mgwdu3pw" />
              <span className="text-sm font-medium text-slate-300 uppercase tracking-wider" data-id="element-201" data-mp="2sccft46zzbud">
                {loc}
              </span>
            </div>)}
        </div>

        {/* International Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark via-gold to-gold-dark rounded-2xl p-1 shadow-gold-glow max-w-4xl mx-auto relative z-10" data-id="element-202" data-mp="9602jsxa495h">
          <div className="bg-navy rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between text-center md:text-left" data-id="element-203" data-mp="rvq4r13dfx7f">
            <div className="flex items-center mb-4 md:mb-0" data-id="element-204" data-mp="nvo0ck694pog">
              <Globe className="w-8 h-8 text-gold mr-4 hidden sm:block" data-id="element-205" data-mp="j3edjd0fo5qe" />
              <div data-id="element-206" data-mp="j1bg47wybabn">
                <h4 className="text-white font-heading font-bold text-xl uppercase mb-1" data-id="element-207" data-mp="e4tdbdl6lm1y">
                  International Operations Available
                </h4>
                <p className="text-slate-400 text-sm" data-id="element-208" data-mp="1bm1x2nzs7cpd">
                  Contact us for international transport and maintenance
                  inquiries.
                </p>
              </div>
            </div>
            <a href="#contact" className="bg-gold hover:bg-gold-light text-navy font-bold py-3 px-6 rounded-full transition-all whitespace-nowrap text-sm uppercase tracking-wide" data-id="element-209" data-mp="1e6q70k0v0vr1">
              Inquire Now
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}